import { useCallback, useState } from "react";

// One shared row-density preference across the estimating grid, bid leveling and
// rollup tables. Persisted in localStorage so it's remembered for the user.
const KEY = "gridforge-grid-density";

export function useDensity() {
  const [density, setDensity] = useState(() => {
    try { return localStorage.getItem(KEY) || "comfortable"; } catch { return "comfortable"; }
  });
  const toggle = useCallback(() => {
    setDensity((d) => {
      const next = d === "compact" ? "comfortable" : "compact";
      try { localStorage.setItem(KEY, next); } catch { /* ignore */ }
      return next;
    });
  }, []);
  const compact = density === "compact";
  return {
    density,
    compact,
    toggle,
    rowPad: compact ? "py-1" : "py-2.5",
    cellPad: compact ? "py-1" : "py-2",
  };
}
